// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

// helpers
import { getStatusBannerMaxHeight } from "@dineout-payment-success-ui/helpers/index";

// styles
import styled from "styled-components";

// constants
import { STATUS_BANNER, STATUS_TEXT_STYLES } from "@dineout-payment-success-ui/constants";
import { SuperButton as Button } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

const QR_TEXT_WIDTH = "236px";
const QR_IMAGE_WIDTH = "100px";
const PARTIAL_PAYMENT_BUTTON_MIN_WIDTH = "140px";

interface IColorKey {
    colorKey: keyof IColors;
    textColor?: string;
}

export const StatusBannerWrapper = styled.div<{
    showStatusDescription: boolean;
    hasSubscription: boolean;
    isEventReservation: boolean;
    isPartialPayment: boolean;
}>(({ showStatusDescription, hasSubscription, isEventReservation, isPartialPayment }) => ({
    textAlign: "center",
    position: "relative",
    maxHeight: getStatusBannerMaxHeight(showStatusDescription, hasSubscription, isEventReservation, isPartialPayment),
    overflow: "hidden",
}));

export const StatusText = styled.div<IColorKey>(({ textColor, colorKey, theme }) => ({
    color: textColor || theme.colors[theme.colorMode][colorKey],
    fontFamily: "Sacramento",
    fontStyle: "normal",
    fontSize: STATUS_TEXT_STYLES.SIZE,
    fontWeight: STATUS_TEXT_STYLES.WEIGHT,
    lineHeight: STATUS_TEXT_STYLES.LINE_HEIGHT,
    letterSpacing: STATUS_TEXT_STYLES.LETTER_SPACING,
    paddingBottom: theme.spacing.xxSmall,
}));

export const TextWrapper = styled.div({
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    top: STATUS_BANNER.TEXT_WRAPPER_TOP,
    width: "100%",
});

export const StyledImage = styled(Image)({
    height: "100%",
    objectFit: "cover",
    width: "100%",
});

export const QRText = styled(Text)<IColorKey>(({ textColor, colorKey, theme }) => ({
    width: QR_TEXT_WIDTH,
    color: textColor || theme.colors[theme.colorMode][colorKey],
}));

export const TicketTextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    alignItems: "center",
}));

export const QRImageContainer = styled.div(({ theme }) => ({
    position: "relative",
    padding: theme.spacing.xSmall,
    width: QR_IMAGE_WIDTH,
    height: QR_IMAGE_WIDTH,
    marginBottom: theme.spacing.xLarge,
}));

export const QRImageWrapper = styled.div(({ theme }) => ({
    overflow: "hidden",
    width: "100%",
    height: "100%",
    borderRadius: theme.cornerRadius.xSmall,
}));

export const CornerAccents = styled.div(({ theme }) => ({
    position: "absolute",
    inset: 0,
    "& > span": {
        position: "absolute",
        inset: 0,
        "&::before, &::after": {
            content: '""',
            position: "absolute",
            width: theme.spacing.medium,
            height: theme.spacing.small,
            border: `2px solid ${theme.colors[theme.colorMode].positive}`,
        },
        "&::before": {
            top: 0,
            right: -5,
            borderLeft: "none",
            borderBottom: "none",
            borderTopRightRadius: theme.cornerRadius.xSmall,
        },
        "&::after": {
            bottom: 0,
            left: -5,
            borderRight: "none",
            borderTop: "none",
            borderBottomLeftRadius: theme.cornerRadius.xSmall,
        },
    },
    "&::before, &::after": {
        content: '""',
        position: "absolute",
        width: theme.spacing.medium,
        height: theme.spacing.small,
        border: `2px solid ${theme.colors[theme.colorMode].positive}`,
    },
    "&::before": {
        top: 0,
        left: -5,
        borderRight: "none",
        borderBottom: "none",
        borderTopLeftRadius: theme.cornerRadius.xSmall,
    },
    "&::after": {
        bottom: 0,
        right: -5,
        borderLeft: "none",
        borderTop: "none",
        borderBottomRightRadius: theme.cornerRadius.xSmall,
    },
}));

export const PartialPaymentButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing.small,
    minWidth: PARTIAL_PAYMENT_BUTTON_MIN_WIDTH,
}));

export const PartialPaymentButtonText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_inverse_Highest_Emphasis,
}));
